import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import App from './App.vue'
import router from './router.js'

Vue.use(ElementUI)

axios.interceptors.request.use((config) => {
  try {
    const token = String(localStorage.getItem('shicigame_token') || "")
    if (token && !config.headers?.Authorization) {
      config.headers = config.headers || {}
      config.headers.Authorization = 'Bearer ' + token
    }
  } catch (e) {
  }
  return config
})

axios.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status
    if (status === 401) {
      try {
        const token = String(localStorage.getItem('shicigame_token') || "")
        if (token) {
          localStorage.removeItem('shicigame_token')
          localStorage.removeItem('shicigame_user')
          window.dispatchEvent(new Event('shicigame-auth-changed'))
        }
      } catch (e) {
      }
      const loginPath = router.currentRoute.path.indexOf('/manager') === 0 ? '/manager/login' : '/login'
      if (router.currentRoute.path !== loginPath) {
        router.replace({ path: loginPath, query: { redirect: router.currentRoute.fullPath } })
      }
    }
    return Promise.reject(error)
  }
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
